import { useEffect } from 'react';
import { getSessionStorageValue, STORAGE_KEYS } from '../SessionStorage';
import { VOUCHER_SESSION_KEYS } from '../../Context/Voucher/VoucherContext';

/**
 * Warn user when closing tab/browser with any in-progress, unsaved selection
 * anywhere in the app — an active booking hold, services/guests picked but not
 * yet held, or vouchers selected. Shows the browser's native "leave site?"
 * confirmation (browsers render their own generic wording; the message string
 * here is only used by older browsers that still display custom text).
 */
export const usePreventBrowserClose = () => {
  useEffect(() => {
    const handleBeforeUnload = (e) => {
      const bookingId = getSessionStorageValue(STORAGE_KEYS.BOOKING_ID);
      const isTimerActive = getSessionStorageValue(STORAGE_KEYS.TIMER_ACTIVE);
      const hasActiveBooking = Boolean(bookingId) && Boolean(isTimerActive);

      const members = getSessionStorageValue(STORAGE_KEYS.UPDATED_MEMBERS);
      const hasSelectedServices =
        Array.isArray(members) &&
        members.some((member) => Array.isArray(member?.services) && member.services.length > 0);

      const selectedVouchers = getSessionStorageValue(VOUCHER_SESSION_KEYS.selectedVouchers);
      const hasSelectedVouchers = Array.isArray(selectedVouchers) && selectedVouchers.length > 0;

      if (!hasActiveBooking && !hasSelectedServices && !hasSelectedVouchers) return;

      const message = hasActiveBooking
        ? 'Changes will be lost. Your booking hold will remain active for 10 minutes.'
        : hasSelectedServices
          ? 'Changes will be lost. Your selected services will not be saved.'
          : 'Changes will be lost. Your selected vouchers will not be saved.';
      e.preventDefault();
      e.returnValue = message;
      return message;
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, []);
};
